import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ListPrice = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
`;

export const CurrentPrice = styled.span`
  margin: 0;
`;

export const Quantity = styled.span`
  margin-left: 3px;
  color: ${p => p.theme.text.quaternary};
  font-size: ${layout.fontSizes.small.desktop.rem};
  font-weight: normal;
  align-self: flex-end;
`;
